import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CustomReportsService,
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto,
} from '../../services/wealthlane-report-services';

interface ImportPayload {
  CustomReport: File;
}

const usePostImportCustomReportJson = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto,
  unknown,
  ImportPayload,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: ImportPayload) => {
      return await handleRequest(
        CustomReportsService.postApiReportApiAppCustomReportsImportCustomReportJson({
          CustomReport: payload.CustomReport,
        })
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto
      ) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message='Custom report imported.' />);
          await queryClient.invalidateQueries('getCustomReportList');
        }
      },
      onError: (err: any) => {
        console.log('Custom report import error:', err);
      },
    }
  );
};

export default usePostImportCustomReportJson;
